"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../../../../basics/Icon"));
var styles_1 = require("./styles");
var LEVEL = {
    '1': '2',
    '2': '3',
};
var IconButton = react_1.default.forwardRef(function (_a, ref) {
    var href = _a.href, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onClick = _a.onClick, iconName = _a.iconName, icon = _a.icon, _c = _a.level, level = _c === void 0 ? '2' : _c, children = _a.children, badge = _a.badge, commonProps = __rest(_a, ["href", "disabled", "onClick", "iconName", "icon", "level", "children", "badge"]);
    var componentProps = __assign(__assign({}, commonProps), { ref: ref,
        disabled: disabled,
        onClick: onClick,
        level: level, $hasText: !!children });
    if (typeof href === 'string') {
        return (react_1.default.createElement(styles_1.LinkWrapper, __assign({ "data-component-name": "IconButton", href: href }, componentProps),
            iconName ? react_1.default.createElement(Icon_1.default, { name: iconName }) : icon ? react_1.default.createElement(styles_1.Custom, null, icon) : null,
            icon,
            children && react_1.default.createElement(styles_1.Text, { level: LEVEL[level] },
                " ",
                children),
            badge && react_1.default.createElement(styles_1.Badge, null, badge)));
    }
    var buttonProps = {
        onClick: onClick,
    };
    return (react_1.default.createElement(styles_1.ButtonWrapper, __assign({ "data-component-name": "IconButton" }, buttonProps, componentProps, { "aria-label": commonProps.ariaLabel }),
        iconName ? react_1.default.createElement(Icon_1.default, { name: iconName }) : icon ? react_1.default.createElement(styles_1.Custom, null, icon) : null,
        children && react_1.default.createElement(styles_1.Text, { level: LEVEL[level] }, children),
        badge && react_1.default.createElement(styles_1.Badge, null, badge)));
});
exports.default = IconButton;
